import React, { type SyntheticEvent, useRef } from "react";
import * as Styles from "../../../../../../common-deprecated/styles/v2/lexus/components/Pill";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import type { PosType } from "../../../../../../common-deprecated/types/CommonTypes";
import { getOffsetRect } from "../../../../../../shared-logic/features/filters/utils/helpers";
import SrOnly from "../../../../../../common-deprecated/styles/v2/lexus/utilities/ScreenreaderOnly";
import { useModelFilterLabel } from "../../../utils/labels";

type FilterPillButtonType = {
    children: React.ReactNode;
    isPrimary?: boolean;
    isLight?: boolean;
    onClick: (pos: PosType) => void;
    closeFn?: () => void;
    disabled?: boolean;
    isSelected: boolean;
    ariaControlsId?: string;
};

const FilterPillButton = ({
    children,
    closeFn,
    onClick,
    isPrimary,
    isLight,
    disabled,
    ariaControlsId,
    isSelected,
}: FilterPillButtonType): JSX.Element => {
    const pillButtonRef = useRef<HTMLButtonElement>(null);

    const isCloseFn = !!closeFn;
    const addFilterLabel = useModelFilterLabel(["modelfilterA11yButtonAddFilter"]);

    return (
        <Styles.Wrapper
            isPrimary={isPrimary}
            onClick={() => {
                if (!disabled && pillButtonRef.current) {
                    const { left: x, bottom: y } = getOffsetRect(pillButtonRef.current);

                    onClick({ x, y });
                }
            }}
            disabled={!!disabled}
            isActive={isCloseFn}
            isLight={isLight}
            isSelected={isSelected}
            ref={pillButtonRef}
            aria-controls={ariaControlsId}
            aria-expanded={isSelected}
        >
            <SrOnly>{addFilterLabel}</SrOnly>
            <Styles.Text isActive={isCloseFn}>{children}</Styles.Text>
            {/*
            Info: Do not add a tabindex on the close icon here, it would result in a button inside of a button. This button can be ignored as the modals themselves have a remove filter option
            */}
            <IconWrapper
                onClick={
                    closeFn
                        ? (event: SyntheticEvent) => {
                              // Prevent click on wrapper
                              event.preventDefault();
                              event.stopPropagation();
                              closeFn();
                          }
                        : undefined
                }
                aria-hidden="true"
            >
                <Icon variant={isCloseFn ? "close" : "plus"} />
            </IconWrapper>
        </Styles.Wrapper>
    );
};

export default FilterPillButton;
